export const DEEP_LINK = ['#chatty-home', '#chatty-chat', '#chatty-tracking', '#chatty-help'];
export const listDeeplink = [
  {
    section: 'Home',
    key: '#chatty-home'
  },
  {
    section: 'Message',
    key: '#chatty-chat'
  },
  {
    section: 'Order tracking',
    key: '#chatty-tracking'
  },
  {
    section: 'Help',
    key: '#chatty-help'
  }
];
